module.exports = __webpack_public_path__ + "img/btn_banner_server.54d7a314.png";